import { render, staticRenderFns } from "./typeItem.vue?vue&type=template&id=0f2ba474&scoped=true"
import script from "./typeItem.vue?vue&type=script&lang=js"
export * from "./typeItem.vue?vue&type=script&lang=js"
import style0 from "./typeItem.vue?vue&type=style&index=0&id=0f2ba474&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2ba474",
  null
  
)

export default component.exports